import { t } from "i18next";

export function Education() {
  return(
    <section id="education" className="dark-bg">
    <div className="content-wrapper">
      <div className="wrap-flow">
        <div className="center">
          <h2>{t('education-title')}</h2>
          <h3>{t('education-degree')}</h3>
          <h3>{t('education-university')}</h3>
        </div>
        <div className="grid grid-column-auto border-separator wrap-flow edu-items">
          <div className="edu-item">
            <h3>{t('education-major')}</h3>
            <ul className="no-deco">
              <li>{t('education-major1')}</li>
              <li>{t('education-major2')}</li>
              <li>{t('education-major3')}</li>
            </ul>
          </div>
          <div className="edu-item">
            <h3>{t('education-minor')}</h3>
            <ul className="no-deco">
              <li>{t('education-minor1')}</li>
              <li>{t('education-minor2')}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}